module.exports = __webpack_public_path__ + "static/media/keypad.0366d5e1.png";